import { withLocalState } from 'pyradux';

import AccountsContainer from './Accounts.container';
import reducer from './Accounts.reducer';
import AccountsSagas from './Accounts.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'accounts',
  sagas: [AccountsSagas],
};

export default withLocalState(withLocalStateOptions, AccountsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Accounts/index.js